import React from "react";

export default function LinksPage() {
  return (
    <>
      <section className="links_pages">
        <div className="Call_phone">
          <a href="tel:64742216">
            <i class="fa fa-phone" aria-hidden="true"></i>{" "}
            <span>Call Now </span>
          </a>
        </div>
        <div className="Whatshap">
          <a href="https://wa.me/6597767615" target="_blank">
            <i class="fa fa-whatsapp" aria-hidden="true"></i>
            <span>WhatsApp</span>
          </a>
        </div>
      </section>
    </>
  );
}
